<div (contextmenu)="manageContextMenu($event)" (click)="manageClick($event)" 
  class="layer start-menu-layer">

  <app-start-menu></app-start-menu>

</div>